import _ from 'lodash';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ReactSVG } from 'react-svg';

import FooterActions from '../../redux/actions/footer';
import Label from '../Label';


const Input = ({
  label,
  type,
  value,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  error,
  className,
  direction,
  infoTagValue,
  withInfoTag,
  isDisabled,
  name,
  min,
  max,
  maxLength,
  inputRef,
  shouldHideFooter,
  withIcon,
  iconClassName,
  iconSrc,
  onIconClick,
  onKeyDown,
}) => {
  const ref = inputRef || useRef(null);
  const inputClassName = clsx('input', type, className, !_.isEmpty(error) && 'invalid');
  const dispatch = useDispatch();

  // const handleFocus = () => {
  // hide Footer when focused input
  // if (shouldHideFooter) dispatch(FooterActions.hideFooter());
  // };

  const handleBlur = (e) => {
    if (shouldHideFooter) dispatch(FooterActions.showFooter());
    if (!onBlur) return;
    onBlur(e);
  };

  return (
    <div className="input--wrapper">
      {label && (
        <Label
          htmlFor={inputClassName}
          value={label}
          infoTagValue={infoTagValue}
          withInfoTag={withInfoTag}
        />
      )}
      <span className="input--wrapper-inner">
        <input
          ref={ref}
          className={inputClassName}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={handleBlur}
          onKeyDown={onKeyDown}
          value={value}
          name={name}
          type={type}
          placeholder={placeholder}
          style={{ textAlign: direction === 'rtl' ? 'right' : 'initial' }}
          min={min}
          max={max}
          maxLength={maxLength}
          disabled={isDisabled}
        />
        {!withIcon || (
          <span
            role="button"
            tabIndex="0"
            className={iconClassName}
            onClick={onIconClick}
          >
            <ReactSVG wrapper="span" src={iconSrc} />
          </span>
        )}
      </span>
      {error && error.length > 0 && (
        <span className="input--error">
          {error}
        </span>
      )}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf([
    'text',
    'password',
    'number',
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  error: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  direction: PropTypes.oneOf(['rtl', 'ltr']),
  withInfoTag: PropTypes.bool,
  infoTagValue: PropTypes.string,
  name: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  maxLength: PropTypes.number,
  inputRef: PropTypes.shape({}),
  isDisabled: PropTypes.bool,
  shouldHideFooter: PropTypes.bool,
  withIcon: PropTypes.bool,
  iconClassName: PropTypes.string,
  iconSrc: PropTypes.string,
  onIconClick: PropTypes.func,
  onKeyDown: PropTypes.func,
};

Input.defaultProps = {
  label: null,
  placeholder: null,
  className: 'default',
  direction: 'ltr',
  type: 'text',
  error: null,
  withInfoTag: false,
  infoTagValue: '',
  value: '',
  name: null,
  onFocus: null,
  onBlur: null,
  min: null,
  max: null,
  maxLength: null,
  inputRef: null,
  isDisabled: false,
  shouldHideFooter: true,
  withIcon: false,
  iconClassName: '',
  iconSrc: '',
  onIconClick: null,
  onKeyDown: null,
};

export default Input;
